import { render, staticRenderFns } from "./request-sent.vue?vue&type=template&id=2447cb94&scoped=true"
import script from "./request-sent.vue?vue&type=script&lang=js"
export * from "./request-sent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2447cb94",
  null
  
)

export default component.exports